import type { AvailableLocalesCode } from '@utils/availableLocales';

export const sleep = (ms: number) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const getSecondsAsMs = (seconds: number) => {
    return seconds * 1000;
};

export const getMinutesAsSeconds = (minutes: number) => {
    return minutes * 60;
};

export const getHoursAsMinutes = (hours: number) => {
    return hours * 60;
};

export const getHoursAsSeconds = (hours: number) => {
    const minutes = getHoursAsMinutes(hours);
    return getMinutesAsSeconds(minutes);
};

export const getHoursAsMs = (hours: number) => {
    const seconds = getHoursAsSeconds(hours);
    return getSecondsAsMs(seconds);
};

export const getMinutesAsHours = (minutes: number) => {
    return minutes / 60;
};

export const formatTime = (
    date: string,
    offsetMs = 0,
    locale: AvailableLocalesCode
) => {
    if (!date) return '';
    const realDate = new Date(new Date(date).getTime() + offsetMs);

    if (locale === 'en') {
        return (
            String(((realDate.getHours() + 11) % 12) + 1).padStart(2, '0') +
            ':' +
            String(realDate.getMinutes()).padStart(2, '0') +
            ' ' +
            String(realDate.getHours() >= 12 ? 'PM' : 'AM')
        );
    }

    return (
        String(realDate.getHours()).padStart(2, '0') +
        ':' +
        String(realDate.getMinutes()).padStart(2, '0')
    );
};

export const formatDate = (date: string, offsetMs = 0) => {
    if (!date) return '';
    const realDate = new Date(new Date(date).getTime() + offsetMs);

    return (
        String(realDate.getFullYear()) +
        '-' +
        String(realDate.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(realDate.getDate()).padStart(2, '0')
    );
};
